/* eslint-disable */
import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import IgniteDataTable from '../common/datatable';
import {dateFormatUK} from '../../utils/commonFunctions';

const columnsDesktop = [
  {
    prop: 'created-at',
    title: 'Date',
    width: '100',
    format: data => dateFormatUK(data)
  },
  {
    prop: 'description',
    title: 'Description',
    width: '270',
    format: data => (<div style={ { whiteSpace: "normal" } }>{data}</div>)
  },
  {
    prop: 'value',
    title: 'Value',
    width: '100',
    format: data => <b>{data}</b>
  },
  {
    prop: 'balance',
    title: 'Balance',
    width: '100',
    format: data => <b>{data}</b>
  },
];

const columnsMobile = [
  {
    prop: 'transaction',
    title: 'Transaction',
    format(data, row) {
      const {
        balance, description, value
      } = row.attributes;
      const createdAt = dateFormatUK(row.attributes['created-at']);
      const balanceClass = +balance > 0 ? 'm-transaction-balance positive' : 'm-transaction-balance negative';

      return (
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="m-transaction-date">{createdAt}</div>
            </Col>
          </Row>
          <Row>
            <Col xs={8}>
              <div style={ { whiteSpace: "normal" } }>{description}</div>
            </Col>
            <Col xs={4} className="ta-right">
              <div>{value}</div>
              <div className={balanceClass}>{balance}</div>
            </Col>
          </Row>
        </Container>
      );
    }
  },
];

class RewardsStatementList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  render() {
    const {
      pointsStatements, pagination, onPageChange, currentPage
    } = this.props;

    const tables = [
      {
        columns: columnsDesktop,
        className: 'd-none d-lg-block'
      },
      {
        columns: columnsMobile,
        className: 'd-block d-lg-none m-transactions'
      }
    ];

    if(!pointsStatements) return <div>No points statement</div>;

    return (
        <Row>
          {tables.map((table) => {
            const {columns, ...props} = table;

            return (
              <Col {...props}>
                <IgniteDataTable
                  data={pointsStatements}
                  dataSize={pagination.number * pagination.size}
                  columns={columns}
                  pagination={{
                    onPageChange,
                    page: currentPage
                  }}
                  remote
                />
              </Col>
            );
          })}
        </Row>
      );
  }
}

export default connect()(RewardsStatementList);
